import { AxiosRequestConfig } from "axios";
import ApiClient from "../../services/apiClient";

export const contact = (data: any, opts?: AxiosRequestConfig) =>
  ApiClient.post("/client/contact", data, opts);

export const requestDemo = (data: any, opts?: AxiosRequestConfig) =>
  ApiClient.post("/client/request_demo", data, opts);
